var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3033 4.69623C14.9779 4.37079 14.4502 4.37079 14.1248 4.69623L10 8.82102L5.87523 4.69623C5.54979 4.37079 5.02215 4.37079 4.69671 4.69623C4.37128 5.02166 4.37128 5.5493 4.69672 5.87474L8.8215 9.99953L4.69671 14.1243C4.37128 14.4498 4.37128 14.9774 4.69671 15.3028C5.02215 15.6283 5.54979 15.6283 5.87523 15.3028L10 11.178L14.1248 15.3028C14.4502 15.6283 14.9779 15.6283 15.3033 15.3028C15.6288 14.9774 15.6288 14.4498 15.3033 14.1243L11.1785 9.99953L15.3033 5.87474C15.6288 5.5493 15.6288 5.02166 15.3033 4.69623Z",
    fill: "#58586B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d3cf14268ee6a8189786b191466888d5.svg";
export { ForwardRef as ReactComponent };